import snakecaseKeys from 'snakecase-keys';
import { ApiService } from '../../ApiService';

export interface PendingTriggerExecutions {
  entriesCount: number;
  page: number;
  nextPage: number | null;
  pageCount: number;
  candidateEmails: string[];
}

export interface GetPendingExecutionsParams {
  perPage?: number;
  offset?: number;
  search?: string;
  updatedAfter?: string;
}

export class TriggerService {
  public static getPendingExecutions(
    triggerId: number,
    params: GetPendingExecutionsParams = {},
  ): Promise<PendingTriggerExecutions> {
    return ApiService.get<PendingTriggerExecutions>(
      `/api/v1/applicant_tracking/triggers/${triggerId}/pending_executions`,
      snakecaseKeys(params),
    );
  }
}
